<template>
    <div class="course-introduce-container" :class="isMobile?'mobile-course-introduce-container':''">
      <img v-if="!isMobile" class="detail-bg" src="@assets/img/index/course-detail-bg.png" alt="">
        <div v-if="!isLoadCourse && !isMobile" class="course-introduce-inner clear-float">
            <div
                    class="collection"
                    @click="collectCourse"
            >
              <img v-if="isCollect" src="@assets/img/index/collect-active-icon.png" alt="">
              <img v-else src="@assets/img/index/collect-icon.png" alt="">
                <div>{{isCollect?'已收藏':'收藏'}}</div>
            </div>
            <a-col :span="8">
                <img :src="courseInfo.coverFileUrl" alt="">
            </a-col>
            <a-col :span="14">
                <li>
                    <header :title="courseInfo.courseTitle">{{courseInfo.courseTitle}}</header>
                </li>

                <li><span style="margin-right: 10px"> 累计{{courseInfo.participationsCount}}人学习</span>
                    <a-rate disabled :value="score" />
                </li>

                <!--免费-->
                <li v-if="isFree">
                    <span style="color: #00CF8C">免费</span>
                </li>
                <!--已经购买-->
                <li v-else-if="isPaid">
                    <span style="color: #FF8000">已拥有</span>
                </li>
                <!--付费-->
                <li v-else-if="!isFree && !isDiscount">
                    <span>￥{{courseInfo.coursePrice }}</span>
                </li>
                <!--付费打折-->
                <li v-else>
                    <span>￥{{courseInfo.discountPrice}}</span>
                    <span >￥{{courseInfo.coursePrice}}</span>
                    <div>
                        <a-tag color="orange">{{courseInfo.discountDesc}}</a-tag>
                    </div>
                </li>

                <li style="width: 750px">
                    <div v-if="isSignUp">
                        <a-button type="primary" @click="toLiveOnlineStudy">立即观看</a-button>
                    </div>

                    <div v-else-if="isFree">
                        <a-button type="primary" style="background-color: #1890ff;border: 1px solid #1890ff "
                                  @click="toSignUp">立即报名
                        </a-button>
                    </div>

                    <div v-else style="text-align: right;margin-top: -20px">
                        <a-button class="buy-now-button" type="primary"
                                  @click="showModal()">立即购买
                        </a-button>
                        <a-button class="join-shop-car" type="primary" @click="joinShoppingCart">加入购物车</a-button>
                    </div>

                </li>
            </a-col>
        </div>
        <div v-else-if="isLoadCourse">
            <a-skeleton style="padding: 20px" active />
        </div>
        <!--移动端样式-->
        <div v-else class="mobile-cover">
          <div class="image-content">
            <img :src="courseInfo.coverFileUrl" alt="">
            <div v-if="isMobile " class="mobile-course-desc-container">
              <div class="mobile-course-desc-inner">
                <h4>{{ courseInfo.courseTitle }}</h4>
                <div>
                  <a-rate disabled allowHalf :value="score" style="font-size: 12px"/>
                  <span class="study-num"> {{ courseInfo.participationsCount }}人学习</span>
                </div>
                <div class="mobile-course-desc-price">
                  <div v-if="isFree" style="margin-top: 8px">
                    <span style="color:#B7BBC4;">免费</span>
                  </div>

                  <div v-else-if="isDiscount">
                    <div>
                      <span class="current-price">￥{{ courseInfo.discountPrice }}</span>
                      <span
                          style="text-decoration: line-through;color: #B7BBC4;font-size: 14px;margin:0 10px">￥{{ courseInfo.coursePrice }}</span>
                    </div>
                    <div>
                      <a-tag color="orange">{{ courseInfo.discountDesc }}</a-tag>
                    </div>
                  </div>

                  <div v-else>
                    <span class="current-price">￥{{ courseInfo.coursePrice }}</span>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div v-if="isLogin" style="display: block;font-size: 12px">
          </div>
        </div>
      <div v-if="isMobile && !isLoadCourse" class="mobile-bottom-action">
        <div class="mobile-bottom-button">
          <div>
            <img v-if="isCollect" src="@assets/img/index/collect-active-icon.png" @click="collectCourse"/>
            <img v-else src="@assets/img/index/collect-icon.png" @click="collectCourse"/>
            <div>{{ isCollect ? '已收藏' : '收藏' }}</div>
          </div>
          <div v-if="!isPaid && !isFree" @click="joinShoppingCart">
            <img src="@assets/img/index/shop-icon-green.png" alt="">
            <div>购物车</div>
          </div>
        </div>
        <div>
          <div v-if="isSignUp">
            <a-button type="primary" @click="toLiveOnlineStudy">立即观看</a-button>
          </div>

          <div v-else-if="isFree">
            <a-button type="primary" @click="toSignUp"
                      style="background-color: #1890ff;border: 1px solid #1890ff ">立即报名
            </a-button>
          </div>
          <!--                <a-button v-if="isPaid || isFree" type="primary" @click="toLiveOnlineStudy">立即观看</a-button>-->
          <a-button v-else type="primary" style="background: #FF8000;border: #FF8000" @click="showModal()">
            立即购买
          </a-button>
        </div>
      </div>
        <!--立即付款弹窗-->
        <a-modal v-model="showPayModel"
                 title="购买课程"
                 cancelText="取消"
                 :okText="okText"
                 :confirmLoading="confirmLoading"
                 @ok="handleOk">
            <div class="modal">
                <p style="margin-bottom: 20px">
                    <a-row>
                        <a-col :span="9"><img :src=courseInfo.coverFileUrl alt=""></a-col>
                        <a-col :span="13" offset="1">{{courseInfo.courseTitle}}</a-col>
                    </a-row>
                </p>
                <p v-if="isDiscount">课程价格：
                    <span style="text-decoration: line-through;color: #FF4F23;font-size: 14px;margin: 0 10px 0 0">￥{{courseInfo.coursePrice}}</span>
                    <span style="color: #E85A26;font-size: 18px;"
                          v-if="courseInfo.isDiscount">￥{{courseInfo.discountPrice }}</span>
                </p>
                <p v-else>
                    课程价格：
                    <span style="color: #FF4F23;font-size: 14px;margin: 0 10px 0 0">￥{{courseInfo.coursePrice}}</span>
                </p>
            </div>
        </a-modal>
    </div>
</template>

<script>
    import common from "../../../mixin/common";
    import {createOrder} from "@api/shopping-api"
    import {showError, showMsg, showSuccessMsg} from "@utils/msg";
    import {COURSE_ALREADY_PAID, SUCCESS} from "@constants/code";
    import {DISPATCH_ADD_CART} from "@constants/action-type/cart-action-type";
    // import {DISPATCH_COLLECT_COURSE} from "@constants/action-type/course-action-type";
    // LIVE_ONLINE_COLLECT_COURSE
    import {
        DISPATCH_LIVE_ONLINE_COLLECT_COURSE,
        DISPATCH_LIVE_ONLINE_SWITCH_SECTION, DISPATH_LIVE_ONLINE_COURSE_INFO
    } from "@constants/action-type/course-live-online-action-type";
    import {COMMIT_CHANGE_IN_SHOPPING_CART} from "@constants/mutation-type/course-mutation-type";
    import {signUp, switchSection} from "@api/course-live-online"
    import {createNamespacedHelpers} from "vuex";
    import {COMMIT_CHANGE_SIGN_UP} from "@constants/mutation-type/course-live-online-mutation-type";

    const {mapState} = createNamespacedHelpers('courseLiveOnline');
    const {mapState: umapStateUser} = createNamespacedHelpers('login');

    // import {LIVE_ONLINE_SWITCH_SECTION} from "@constants/action-type/course-live-online-action-type"
    export default {
        name: "CourseIntroduce",
        mixins: [common],
        data() {
            return {
                //显示确认付款弹框
                showPayModel: false,
                okText: "去付款",
                confirmLoading: false,
            }
        },
        created() {
        },
        methods: {
            collectCourse() {
                if (!this.isLoadCollect && this.isLoginClick()) {
                    if (this.isCollect) {
                        this.$modal.confirm({
                            title: '确认',
                            content: '您确定要取消收藏吗？',
                            onOk: () => {
                                return this.$store.dispatch(DISPATCH_LIVE_ONLINE_COLLECT_COURSE, {courseId: this.courseInfo.courseId})
                            },
                            okText: '确定',
                            cancelText: '取消'
                        })
                    } else {
                        this.$store.dispatch(DISPATCH_LIVE_ONLINE_COLLECT_COURSE, {courseId: this.courseInfo.courseId})
                    }
                }
            },
            // 显示确认付款弹框
            showModal() {
                // this.modalData = item
                if (this.isLoginClick()) {
                    this.showPayModel = true;
                } else {
                    this.showPayModel = false;
                }
            },
            // 订单生成中
            handleOk() {
                this.confirmLoading = true;
                this.okText = "订单生成中...";
                createOrder([this.courseInfo.courseId]).then(res => {
                    if (res.code === SUCCESS) {
                        // todo 跳转到详情界面
                        showSuccessMsg("创建成功，即将跳转到支付界面...");
                        setTimeout(() => {
                            this.$router.push({
                                name: 'payDetail',
                                params: {
                                    orderId: res.order.orderId
                                }
                            })
                        }, 300)
                    } else if (res.code === COURSE_ALREADY_PAID) {
                        showMsg("已自动帮您忽略了您已拥有的课程");
                    } else {
                        showError('创建订单失败', res.msg);
                    }
                    this.confirmLoading = true;
                })
            },

            //  加入购物车
            joinShoppingCart() {
                if (this.isLoginClick()) {
                    if (!this.isInShoppingCart) {
                        this.$store.dispatch({
                            type: DISPATCH_ADD_CART,
                            courseId: this.courseInfo.courseId
                        }).then(res => {
                            if (res.code === SUCCESS) {
                                // 设置该课程为已加入购物车
                                this.$store.commit(COMMIT_CHANGE_IN_SHOPPING_CART, {isInShoppingCart: true})
                            }
                        })
                    } else {
                        showMsg("该课程已经在购物车里")
                    }
                }
            },

            //    报名
            toSignUp() {
                if (this.isLoginClick()) {
                    signUp(this.courseInfo.courseId).then((res) => {
                        console.log(res)
                        if (res.code == 0) {
                            // this.isSignUp = true
                            this.$store.commit(COMMIT_CHANGE_SIGN_UP, {isSignUp: true});
                            this.$store.dispatch(DISPATH_LIVE_ONLINE_COURSE_INFO, {courseId: this.courseInfo.courseId});
                            showSuccessMsg("报名成功，快开始学习吧！")
                        } else {
                            console.error(res.msg)
                        }
                    })
                }

            },

            //    去直播间
            toLiveOnlineStudy() {
                console.log("跳转到直播间")
                if (this.isLoginClick()) {
                    console.log(this.courseInfo.nextLiveSectionId)

                    if (this.courseInfo.nextLiveSectionId === -1) {
                        showMsg("该课程已全部直播结束，请点击下方章节查看回放！")
                    } else {

                        // console.log(this.courseInfo)
                        switchSection(this.courseInfo.nextLiveSectionId).then((res) => {
                            console.log(res)
                            if (res.section.liveStatus === "1" || this.isLiveSwitch) {
                                //切换章节
                                const payload = {
                                    sectionId: this.courseInfo.nextLiveSectionId,
                                    canTry: true
                                };
                                this.$store.dispatch(DISPATCH_LIVE_ONLINE_SWITCH_SECTION, payload)
                                // // 跳转到播放界面
                                this.$router.push({
                                    name: 'courseOnlineStudy',
                                    params: {
                                        courseId: this.courseInfo.courseId,
                                    },
                                    query: {
                                        sectionId: this.courseInfo.nextLiveSectionId,
                                        nextLiveSectionId: this.courseInfo.nextLiveSectionId,
                                    }
                                })
                            } else {
                                showMsg("该课程暂无章节正在直播")
                            }
                        })

                    }
                }

            }

        },
        computed: {
            ...mapState({
                isPaid: 'isPaid',
                isCollect: 'isCollect',
                isInShoppingCart: "isInShoppingCart",
                courseInfo: 'courseInfo',
                isLoadCourse: 'isLoadCourse',
                isLoadCollect: "isLoadCollect",
                score: "score",
                isSignUp: "isSignUp"
            }),
            ...umapStateUser({
                userInfo: "userInfo"
            }),
            isDiscount() {
                return this.$func.isTrue(this.courseInfo.isDiscount);
            },
            isFree() {
                return this.$func.isTrue(this.courseInfo.isFree);
            },
            isLiveSwitch() {
                if (this.userInfo.roles) {
                    for (let i = 0; i < this.userInfo.roles.length; i++) {
                        if (this.userInfo.roles[i].roleKey === "teacher" || this.userInfo.roles[i].roleKey === "admin") {
                            return true
                        } else {
                            return false
                        }
                    }
                }
                return false;
            }
        },
    }
</script>

<style scoped lang="less">
.buy-now-button{
  width: 121px;
  height: 40px;
  background: linear-gradient(90deg, #FD952D 0%, #F1534B 100%);
  border-radius: 20px;
  font-weight: 500;
  font-size: 18px;
  margin-right: 15px;
  border: none;
}
.mobile-bottom-button{
  display: flex;
  align-items: center;
  img{
    width: 16px;
  }
  >div{
    text-align: center;
    margin-right: 23px;
    font-size: 12px;
    color: #333;
  }
}
.join-shop-car{
  width: 121px;
  height: 40px;
  background: #FFE9E9;
  border-radius: 24px;
  font-size: 18px;
  font-weight: 500;
  color: #F1534B;
  border:none;
}
/deep/.ant-tag-orange{
  background: linear-gradient(48deg, #FE26B8 0%, #F7283F 23%, #FC3D3F 72%, #FF8D2A 100%) !important;
  border-radius: 3px;
  color: #FFFFFF;
}
    .course-introduce-container {
        width: 100%;
        position: relative;
        background: white;
        border-radius: 15px;
        .detail-bg{
          position: absolute;
          top: 0;
          left: calc(50% - 114px);
        }
        .course-introduce-inner {
            padding: 20px;

            img {
                width: 330px;
                height: 220px;
                border-radius: 12px;

            }

            li {
                header {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 30px;
                    font-weight: 500;
                    color: #333333;
                }

                margin: 10px 0;
                font-size: 24px;

                button {
                    width: 160px;
                    height: 45px;
                    font-size: 18px;
                    margin-right: 10px;
                }
            }

            li:nth-of-type(2) {
                font-size: 14px;
                color: #B7BBC4;
            }

            li:nth-of-type(3) {
                height: 70px;
              //优惠后价格
              &>:nth-child(1){
                font-size: 26px;
                font-weight: 600;
                color: #F32425;
              }
              &>:nth-child(2){
                font-weight: 500;
                color: #B7BBC4;
                font-size: 14px;
                text-decoration: line-through;
                margin:0 10px;
              }
            }

        }

        .collection {
            cursor: pointer;
            width: 110px;
            height: 30px;
            font-size: 16px;
            display: flex;
            flex-direction: column;
            align-items: center;
            float: right;
            color: #999999;
            position: absolute;
            right: 30px;
            top: 30px;

          img{
            width: 18px;
            height: 18px;
            margin-bottom: 4px;
          }
        }


    }

    .modal {
        p {
            img {
                width: 100%;
            }
        }
    }

    .mobile-course-introduce-container {
        display: flex;

        .mobile-cover {
          padding: 10px;
          border-radius: 6px;
          width: 100%;
          height: auto;
          .image-content {
            display: flex;

            .mobile-course-desc-container {
              .mobile-course-desc-inner {
                h4 {
                  width: 100%;
                  font-weight: 500;
                  color: #333;

                }

                .study-num {
                  margin-right: 10px;
                  font-size: 12px;
                  color: #B7BBC4;
                }
              }
            }
          }
            img {
              width: 40%;
              border-radius: 6px;
              margin-right: 10px;
            }
        }

        .mobile-bottom-action {
            position: fixed;
            bottom: 0;
            left: 0;
            height: 50px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            background: white;
            padding: 0 20px;
            align-items: center;
            z-index: 100;
            border-top: 1px solid rgba(221, 221, 221, 0.4);
        }
    }

    .Learning-progress-bar {
        width: 200px;
        float: right;

        dt {
            font-size: 13px;
            color: #00CF8C;
            text-align: right;
        }
    }

</style>
